export default {
    isAuthenticated(state) {
        return state.token != null
    },
    getMenu(state) {
        return state.menu;
    },
    getLayoutMode(state) {
        return state.layoutMode;
    },
    adminPermissions(state) {
        return state.adminPermissions;
    },
};
